import axios from 'axios'

import { getToken } from 'firebase/messaging'
import { messaging } from '../../infra/firebase/firebase-app'

import { settings } from '../../main/configs/settings'

export default class HelperNotificationToken {
  static baseUrl = 'https://iid.googleapis.com/iid/v1'

  static workerPath = '/firebase-messaging-sw.js'

  static vapidKey = settings.vapidKey as string

  static async requestPermission() {
    Notification.requestPermission(async (status) => {
      if (status === 'granted') {
        navigator.serviceWorker
          .register(HelperNotificationToken.workerPath)
          .then(async (registration) => {
            if (!messaging) {
              console.error('Firebase messaging is not initialized')
              return
            }

            const currentToken = await getToken(messaging, {
              vapidKey: HelperNotificationToken.vapidKey,
              serviceWorkerRegistration: registration,
            })

            if (currentToken) {
              await HelperNotificationToken.sendTokenToServer(currentToken)
              console.log('Token enviado para o servidor')
            } else {
              console.log('Token não encontrado')
            }
          })
      }
    })
  }

  static async sendTokenToServer(token: string) {
    if (!HelperNotificationToken.isTokenSentToServer()) {
      const authority = localStorage.getItem('authority')

      try {
        await axios.post(
          `${HelperNotificationToken.baseUrl}/${token}/rel/topics/${authority}`,
          {},
          {
            headers: {
              Authorization: `key=${settings.serverKey}`,
            },
          },
        )
        localStorage.setItem('tokenSentToServer', '1')
      } catch (error) {
        console.error(error)
      }
    }
  }

  static isTokenSentToServer() {
    return localStorage.getItem('tokenSentToServer') === '1'
  }
}
